import { CHANGE_LANGUAGE } from 'redux/actions/types';
import { defaultLanguage } from 'utils/functions';

const INIT_STATE = {
    currentLanguage: defaultLanguage('ja'),
};

const configReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case CHANGE_LANGUAGE: {
            return { ...state, currentLanguage: action.payload.language };
        }
        default: {
            return { ...state };
        }
    }
};

export default configReducer;
